





































import { ContentLoader } from 'vue-content-loader';

const DEFAULT_ICON_URL = '/static/images/connectors/plug.svg';

interface Connector {
  name: string;
  iconUrl: string | null;
  description: string;
  url: string;
}

export default {
  name: 'Tile',
  components: {
    ContentLoader,
  },
  props: {
    connector: {
      type: Object as () => Connector,
      default: null,
    },
  },
  computed: {
    icon() {
      return this.connector.iconUrl || DEFAULT_ICON_URL;
    },
  },
};
